import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { SwitchNode } from '../../types';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { SWITCH_SOURCE_HANDLES } from '../switchHandles';
import { CardShell } from '../CardShell';

/**
 * Switchカードの表示コンポーネント
 * - 2つの比較文字列を設定する
 * - 入力値との一致結果で3本の出力を切り替える
 */
export const SwitchNodeView = memo(function SwitchNodeView({
  data,
}: NodeProps<SwitchNode>) {
  const displayLanguage = useFlowDisplayLanguage();
  const value1 = data.matchValue1 ?? '';
  const value2 = data.matchValue2 ?? '';
  const summary = value1 || value2 ? `${value1 || '—'} / ${value2 || '—'}` : '';

  return (
    <CardShell
      kind="switch"
      accent="indigo"
      title={getNodeDisplayLabel('switch', displayLanguage)}
      summary={summary}
    >
      <div className="flow-node__port-label flow-node__port-label--in text-indigo-700" style={{ top: '50%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'input' : '入力'}
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-indigo-700" style={{ top: '26%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'no match' : 'どちらでもない'}
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-indigo-700" style={{ top: '50%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'same as 1' : 'ことば1と同じ'}
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-indigo-700" style={{ top: '74%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'same as 2' : 'ことば2と同じ'}
      </div>

      <Handle
        type="target"
        position={Position.Left}
        style={{ top: '50%' }}
        className="!bg-indigo-500"
      />
      <Handle
        id={SWITCH_SOURCE_HANDLES.default}
        type="source"
        position={Position.Right}
        style={{ top: '26%' }}
        className="!bg-indigo-500"
      />
      <Handle
        id={SWITCH_SOURCE_HANDLES.match1}
        type="source"
        position={Position.Right}
        style={{ top: '50%' }}
        className="!bg-indigo-500"
      />
      <Handle
        id={SWITCH_SOURCE_HANDLES.match2}
        type="source"
        position={Position.Right}
        style={{ top: '74%' }}
        className="!bg-indigo-500"
      />
    </CardShell>
  );
});
